import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Card, Col, Row } from 'react-bootstrap';
import { getColor } from 'helpers/utils';
import SimpleBarReact from 'simplebar-react';
import FalconCardHeader from 'components/common/FalconCardHeader';

const TotalImporter = ({
  importers,
  values,
  valoresConvertidos,
  title,
  heightSize,
  height
}) => {
  const sortedImporters = [...importers].reverse();
  const sortedValues = [...values].reverse();
  const sortedValoresConvertidos = [...valoresConvertidos].reverse();

  const getAxisLabelFormatter = () => {
    const screenWidth = window.innerWidth;

    // Defina os limites de comprimento do texto com base na largura da tela
    let maxLength;
    if (screenWidth > 1024) {
      // Largura de tela grande
      maxLength = 60;
    } else if (screenWidth >= 768 && screenWidth <= 1024) {
      // Largura de tela média
      maxLength = 20;
    } else {
      // Largura de tela pequena
      maxLength = 14;
    }

    return value =>
      value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
  };

  const getOption = () => {
    const maxValue = Math.max(...sortedValues);
    const interval = Math.ceil(maxValue / 50000);
    return {
      tooltip: {
        trigger: 'item',
        transitionDuration: 0,
        backgroundColor: getColor('gray-100'),
        borderColor: getColor('gray-300'),
        textStyle: {
          fontSize: 10,
          color: getColor('gray-1100')
        },
        formatter: params => {
          const index = sortedImporters.indexOf(params.name);
          const valorConvertido = sortedValoresConvertidos[index];
          return `<strong>${params.name}</strong>: ${
            valorConvertido.toLocaleString()
          }`;
        }
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          interval,
          formatter: value => value.toLocaleString()
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#ccc'
          }
        }
      },
      yAxis: {
        type: 'category',
        data: sortedImporters,
        axisLabel: {
          formatter: getAxisLabelFormatter(),
          align: 'right',
          padding: [0, 2, 0, 0],
          margin: 10,
          textStyle: {
            fontSize: 9
          }
        },
        nameGap: 5,
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#ccc'
          }
        }
      },
      series: [
        {
          name: 'Valor',
          type: 'bar',
          data: sortedValues,
          avoidLabelOverlap: false,
          itemStyle: {
            color: getColor('primary')
          },
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false
            }
          }
        }
      ],
      grid: {
        left: '25%',
        right: '4%'
      }
    };
  };

  return (
    <Card className={height} style={{ margin: 0, padding: 0 }}>
      <FalconCardHeader title={title} titleTag="h6" style={{ margin: 0 }} />
      <SimpleBarReact
        style={{
          height: heightSize,
          overflowY: 'hidden',
          margin: 0,
          padding: 0
        }}
        autoHide={false}
      >
        <Card.Body
          className="recent-activity-body-height"
          style={{ margin: 0, padding: 0 }}
        >
          {Array.isArray(sortedImporters) && sortedImporters.length > 0 ? (
          <Row className="justify-content-between g-0" style={{ margin: 0 }}>
            <div
              style={{
                transformOrigin: 'top center',
                marginTop: 0,
                padding: 0
              }}
            >
              <ReactECharts option={getOption()} />
            </div>
          </Row>
          ):(
            <div className="text-center p-3">Sem registros</div>
          )}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

export default TotalImporter;
